<template>
  <div :style="`${isPromotion ? 'padding:20px' : ''}`" class="content">
    <div class="title">淘宝询价人工纠错</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待处理" name="0"></el-tab-pane>
      <el-tab-pane label="已处理" name="1"></el-tab-pane>
    </el-tabs>
    <Search :hiddenExport="true" :loading="searchForm.loading" :optionsStatus="optionsStatus" :optionsType="optionsType"
            :searchForm="searchForm" :searchList="searchList" :isOrderedOptions="isOrderedOptions"></Search>
    <!-- 表格 -->
    <taobao-order-error-table :loading="searchForm.Loading"
                              :order-status="searchForm.orderStatus"
                              :table-list="tableList.list"
                              @refreshData="getList"
    >
    </taobao-order-error-table>
    <!-- 分页 -->
    <el-pagination
      v-if="tableList.total > 0"
      :current-page="currentPage"
      :page-size="tableList.pageSize"
      :page-sizes="[10, 20, 30, 40]"
      :total="tableList.total"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import Search from "@/components/Search";
import mini from "@/api/mini";
import detail from "./components/detail";
import TaobaoOrderErrorTable from "./components/taobaoOrderErrorTable.vue";

const MiniModel = new mini()

export default {
  name: "index",
  components: {
    TaobaoOrderErrorTable,
    Search,
    detail
  },
  data() {
    return {
      activeName: '0',
      searchForm: {
        orderStatus: 0, // 0 待处理 1 已处理
        pageSize: 10,
        pageNo: 1,
        serviceNickName: '',
        shopName: '',
        orderId: '',
        status: '',
        tbOrderId: '',
        time: [],
        operateTime: [],
        inquiryId: '',
        startCreateTime: '',
        endCreateTime: '',
        operateBeginTime: '',
        operateEndTime: '',
        loading: true,
        isOrdered:''
      },
      searchList: [
        {
          id: 'shopName',
          text: '淘宝店铺名称',
          placeholder: '请输入店铺名称',
          type: 'select'
        },
        {
          id: 'status',
          text: '处理状态',
          placeholder: '请选择处理状态',
          type: 'select',
          isHide: true
        },
        {
          id: 'serviceNickName',
          text: '旺旺对接客服',
          placeholder: '请输入客服昵称',
          type: 'input'
        },
        {
          id: 'tbOrderId',
          text: '淘宝订单号',
          isHide: true,
          placeholder: '请输入淘宝订单号',
          type: 'input'
        },
        {
          id: 'orderId',
          text: '订单号',
          isHide: true,
          placeholder: '请输入订单号',
          type: 'input'
        },
        {
          id: 'inquiryId',
          text: '询价单号',
          isHide: false,
          placeholder: '询价单号',
          type: 'input'
        },
        {
          id: 'isOrdered',
          text: '用户是否下单',
          placeholder: '请选择',
          type: 'select'
        },
        {
          id: 'time',
          text: '添加时间',
          type: 'time'
        },
        {
          // 操作时间
          id: 'operateTime',
          isHide: true,
          text: '处理时间',
          type: 'operateTime'
        },
      ],
      tableList: {
        list: [],
        total: 0,
        pageSize: 10
      },
      // 状态 0:初始值 1:未处理 2:下单成功 3:下单失败 4:关闭 5:自动处理 10:推送卡片消息成功
      // 已处理下单，手动关闭，自动推送成功，手动移除
      optionsStatus: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '下单成功',
          value: 2
        },
        {
          label: '手动关闭',
          value: 4
        },
        {
          label: '手动移除',
          value: 6
        },
        {
          label: '推送成功',
          value: 10
        }
      ],
      currentPage: 1,
      optionsType: [{
        label: '全部',
        value: ''
      }],
      isPromotion: false,
      isOrderedOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已下单',
          value: 1
        },
        {
          label: '未下单',
          value: 0
        }
      ]
    }
  },
  mounted() {
    this.getList()
    this.getShopList()
    // 获取hash值
    this.isPromotion = window.location.hash.includes('promotion')
  },
  methods: {
    // 获取淘宝店铺列表
    getShopList() {
      MiniModel.taobaoOcrShopList().then(res => {
        if (res.data.code === 200) {
          this.optionsType = this.optionsType.concat(res.data.data.map(item => {
            return {
              label: item,
              value: item
            }
          }))
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    getList() {
      this.searchForm.loading = true
      MiniModel.taobaoOcrCorrectList(this.searchForm).then(res => {
        this.searchForm.loading = false
        if (res.data.code === 200) {
          this.tableList = res.data.data
        } else {
          this.$message.error(res.data.info)
        }
      }).finally(() => {
      })
    },
    handleClick(e) {
      // 如果是已处理 隐藏 淘宝订单号搜索条件 isHide 为true
      if (e.name === "1") {
        //  显示
        this.searchList.forEach(item => {
          if (item.id === 'tbOrderId') {
            item.isHide = false
          }
          if (item.id === 'orderId') {
            item.isHide = false
          }
          if (item.id === 'status') {
            item.isHide = false
          }
          if (item.id === 'operateTime') {
            item.isHide = false
          }
        })

      } else {
        // 隐藏
        this.searchList.forEach(item => {
          if (item.id === 'tbOrderId') {
            item.isHide = true
          }
          if (item.id === 'orderId') {
            item.isHide = true
          }
          if (item.id === 'status') {
            item.isHide = true
          }
          if (item.id === 'operateTime') {
            item.isHide = true
          }
        })
      }

      // 重置搜索条件
      this.searchForm = {
        orderStatus: e.name === "0" ? 0 : 1,
        pageSize: 10,
        pageNo: 1,
        serviceNickName: '',
        shopName: '',
        orderId: '',
        inquiryId: '',
        status: '',
        tbOrderId: '',
        time: [],
        operateTime: [],
        startCreateTime: '',
        endCreateTime: '',
        operateBeginTime: '',
        operateEndTime: '',
        loading: true,
        isOrdered:'',
      }
      this.searchList.list = []
      this.getList();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
  }
}
</script>
<style>
.el-icon-circle-close {
  color: red;
}

</style>
<style lang="less" scoped>

.content {
  background: #FFFFFF;
  border-radius: 8px;

  .title {
    font-size: 20px;
    color: #222222;
    text-align: left;
    font-weight: bold;
  }
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/taobaoOrderError.vue